import { Component, OnInit } from "@angular/core";
import { ResellerService } from "../reseller-view/reseller.service";
import { ApplicationService } from "../application/application.service";
import { MatTableDataSource } from "@angular/material/table";
import { DashboardService } from "../dashboard/dashboard.service";
import { FormBuilder, Validators } from "@angular/forms";
import * as moment from "moment";
import { forkJoin } from "rxjs";
import { delay } from "rxjs/internal/operators";

@Component({
  selector: "app-reseller-view",
  templateUrl: "./reseller-view.component.html",
  styleUrls: ["./reseller-view.component.scss"],
})
export class ResellerViewComponent implements OnInit {
  loadershow: boolean = false;
  ELEMENT_DATA: any = "";
  resellerList: any = [];
  applicationList: any = [];
  applicationDetails: any;
  connectorList: any = [];
  todaysDate: any = moment().format("YYYY-MM-DD");
  currentWeekStarts: any = moment().startOf("week").format("YYYY-MM-DD");
  currentWeekEnds: any = moment().endOf("week").format("YYYY-MM-DD");
  currentMonthStarts: any = moment().startOf("month").format("YYYY-MM-DD");
  currentMonthEnds: any = moment().endOf("month").format("YYYY-MM-DD");
  currentYearStarts: any = moment().startOf("year").format("YYYY-MM-DD");
  currentYearEnds: any = moment().endOf("week").format("YYYY-MM-DD");
  Loader = false;
  displayedColumns: string[] = [
    "appName",
    "name",
    "renualDate",
    "todaysMessage",
    "weeklyMessage",
    "monthlyMessage",
    "yearlyMessage",
  ];
  dataSource: any = [];
  product: any = [];
  page: number = 1;
  paginationCount: number = 0;
  paginationDisabled: boolean = false;
  sentTodayCount: any;
  sentWeekCount: any;
  sentMonthCount: any;
  sentYearCount: any;
  receiveTodayCount: any;
  receiveWeekCount: any;
  receiveMonthCount: any;
  receiveYearCount: any;
  selectedReseller: any = "";
  constructor(
    private resellerService: ResellerService,
    private applicationService: ApplicationService,
    private dashboardService: DashboardService,
    public fb: FormBuilder
  ) {}

  resellerForm = this.fb.group({
    reseller: ["", [Validators.required]],
  });

  get reseller() {
    return this.resellerForm.get("reseller");
  }

  ngOnInit(): void {
    let userId = JSON.parse(localStorage.getItem("user")).id;
    this.loadershow = true;
    let args = { developerId: userId };
    this.resellerService.getResellerList(args).subscribe(
      (data) => {
        this.loadershow = false;
        if (data.info && data.info.length > 0) {
          this.resellerList = data.info;
        }
      },
      (err) => {
        this.loadershow = false;
        console.log("Error op", err);
      }
    );
  }

  viewApplicationDetails() {
    this.page = 1;
    this.product = [];
    this.loadershow = true;
    let item: any;
    let appArgs = { developerId: this.selectedReseller.developerId };
    this.resellerService.getApplicationList(appArgs).subscribe(
      (data) => {
        if (data.info && data.info.length > 0) {
          this.applicationList = data.info;
          this.paginationCount = this.applicationList.length;
          let app1 = this.applicationList.slice(
            (this.page - 1) * 5,
            (this.page - 1) * 5 + 5
          );
          this.integration(app1);
        } else {
          this.loadershow = false;
          this.ELEMENT_DATA = [];
          this.dataSource = [];
        }
      },
      (err) => {
        this.loadershow = false;
        console.log("Error op", err);
      }
    );
  }

  integration(appliList) {
    this.loadershow = true;
    this.connectorList = [];
    for (let app of appliList) {
      this.openApplication(app);
    }

    setTimeout(() => {
      this.getCounts(this.connectorList);
    }, 8000);
  }

  processEachConnectorData() {
    this.product = this.ELEMENT_DATA;
    let itemsCount = 0;
              if (this.product.length > 1) {
                for (let i = 0; i < this.product.length; i++) {
                  if (this.product[i].name == "Total") {
                    this.product[i].applicationName2 = this.product[
                      i - 1
                    ].applicationName2;
                    let arg1 = {
                      developerId: this.product[i - 1].developerID,
                      applicationId: this.product[i - 1].applicationID,
                      fromDate: this.todaysDate,
                      toDate: this.todaysDate,
                    };

                    let todaysSentMessageDatas = this.applicationService.totalSentMsgCount(
                      arg1
                    );
                    let todaysReceivedMessageDatas = this.applicationService.totalReceivedMsgCount(
                      arg1
                    );

                    let args2 = {
                      developerId: this.product[i - 1].developerID,
                      applicationId: this.product[i - 1].applicationID,
                      fromDate: this.currentWeekStarts,
                      toDate: this.currentWeekEnds,
                    };
                    let weekSentMessageDatas = this.applicationService.totalSentMsgCount(
                      args2
                    );
                    let weekReceivedMessageDatas = this.applicationService.totalReceivedMsgCount(
                      args2
                    );

                    let args3 = {
                      developerId: this.product[i - 1].developerID,
                      applicationId: this.product[i - 1].applicationID,
                      fromDate: this.currentMonthStarts,
                      toDate: this.currentMonthEnds,
                    };
                    let monthSentMessageDatas = this.applicationService.totalSentMsgCount(
                      args3
                    );
                    let monthReceivedMessageDatas = this.applicationService.totalReceivedMsgCount(
                      args3
                    );
                    let args4 = {
                      developerId: this.product[i - 1].developerID,
                      applicationId: this.product[i - 1].applicationID,
                      fromDate: this.currentYearStarts,
                      toDate: this.currentYearEnds,
                    };
                    let yearSentMessageDatas = this.applicationService.totalSentMsgCount(
                      args4
                    );
                    let yearReceivedMessageDatas = this.applicationService.totalReceivedMsgCount(
                      args4
                    );

                    forkJoin([
                      todaysSentMessageDatas,
                      todaysReceivedMessageDatas,
                      weekSentMessageDatas,
                      weekReceivedMessageDatas,
                      monthSentMessageDatas,
                      monthReceivedMessageDatas,
                      yearSentMessageDatas,
                      yearReceivedMessageDatas,
                    ])
                      .pipe(delay(2000))
                      .subscribe((results2) => {
                        this.product[i].todaysSentMessage =
                          results2[0].info.totalCount;
                        this.product[i].todaysReceivedMessage =
                          results2[1].info.totalCount;
                        this.product[i].weekSentMessage =
                          results2[2].info.totalCount;
                        this.product[i].weekReceivedMessage =
                          results2[3].info.totalCount;
                        this.product[i].monthSentMessage =
                          results2[4].info.totalCount;
                        this.product[i].monthReceivedMessage =
                          results2[5].info.totalCount;
                        this.product[i].yearSentMessage =
                          results2[6].info.totalCount;
                        this.product[i].yearReceivedMessage =
                          results2[7].info.totalCount;
                      });
                  }
                  for (let j = 0; j < this.product.length; j++) {
                    if (i !== j) {
                      if (
                        this.product[i].applicationName ===
                        this.product[j].applicationName
                      ) {
                        this.product[j].applicationName = "";
                      }
                    }
                  }
                  itemsCount++;
                }
                //let sortedData = this.product.sort((a, b) => a.applicationName2.localeCompare(b.applicationName2));
                //this.product = sortedData;
                // await  this.totalCountOfMsg();
                // console.log('this.datasor',this.dataSource );

                //   console.log(typeof this.dataSource, typeof xyz);
                //  this.dataSource.splice(0, 0, xyz);

                // console.log('data Source',this.dataSource);
                if (itemsCount == this.product.length) {
                  setTimeout(() => {
                    this.processTotalCountData();
                  }, 1000);
                }
              } else {
                this.ELEMENT_DATA = [];
                this.dataSource = [];
                  setTimeout(() => {
                    this.processTotalCountData();
                  }, 1000);
              }
  }


  processTotalCountData() {    
    this.product = this.ELEMENT_DATA;

          let total = {
            applicationName: "Total Count",
            name: "",
            renualDate: "",
            todaysSentMessage: null,
            todaysReceivedMessage: null,
            weekSentMessage: null,
            weekReceivedMessage: null,
            monthSentMessage: null,
            monthReceivedMessage: null,
            yearSentMessage: null,
            yearReceivedMessage: null,
          };
      this.product.push(total);
    
    let argsw = {
            developerId: this.product[0].developerID,
            fromDate: this.todaysDate,
            toDate: this.todaysDate,
          };
          let sentTodayCountData = this.resellerService.getTotalCount(argsw);
          let receiveTodayCountData = this.resellerService.getTotalReceivedCount(
            argsw
          );

          let argsr = {
            developerId: this.product[0].developerID,
            fromDate: this.currentWeekStarts,
            toDate: this.currentWeekEnds,
          };

          let sentWeekCountData = this.resellerService.getTotalCount(argsr);
          let receiveWeekCountData = this.resellerService.getTotalReceivedCount(
            argsr
          );

          let argst = {
            developerId: this.product[0].developerID,
            fromDate: this.currentMonthStarts,
            toDate: this.currentMonthEnds,
          };
          let sentMonthCountData = this.resellerService.getTotalCount(argst);
          let receiveMonthCountData = this.resellerService.getTotalReceivedCount(
            argst
          );

          let argsy = {
            developerId: this.product[0].developerID,
            fromDate: this.currentYearStarts,
            toDate: this.currentYearEnds,
          };
          let sentYearCountData = this.resellerService.getTotalCount(argsy);
          let receiveYearCountData = this.resellerService.getTotalReceivedCount(
            argsy
          );

          forkJoin([
            sentTodayCountData,
            receiveTodayCountData,
            sentWeekCountData,
            receiveWeekCountData,
            sentMonthCountData,
            receiveMonthCountData,
            sentYearCountData,
            receiveYearCountData,
          ])
            .pipe(delay(2000))
            .subscribe((results1) => {
              this.product[
                this.product.length - 1
              ].todaysSentMessage = results1[0].info.totalCount
                ? results1[0].info.totalCount
                : 0;
              this.product[
                this.product.length - 1
              ].todaysReceivedMessage = results1[1].info.totalCount
                ? results1[1].info.totalCount
                : 0;
              this.product[
                this.product.length - 1
              ].weekSentMessage = results1[2].info.totalCount
                ? results1[2].info.totalCount
                : 0;
              this.product[
                this.product.length - 1
              ].weekReceivedMessage = results1[3].info.totalCount
                ? results1[3].info.totalCount
                : 0;
              this.product[
                this.product.length - 1
              ].monthSentMessage = results1[4].info.totalCount
                ? results1[4].info.totalCount
                : 0;
              this.product[
                this.product.length - 1
              ].monthReceivedMessage = results1[5].info.totalCount
                ? results1[5].info.totalCount
                : 0;
              this.product[
                this.product.length - 1
              ].yearSentMessage = results1[6].info.totalCount
                ? results1[6].info.totalCount
                : 0;
              this.product[
                this.product.length - 1
              ].yearReceivedMessage = results1[7].info.totalCount
                ? results1[7].info.totalCount
                : 0;
            });


          console.table("this.product", this.product);
          this.dataSource = new MatTableDataSource(this.product);
          this.loadershow = false;
  }

  openApplication(conn) {
    let connArgs = {
      developerId: conn.developerId,
      applicationId: conn.id,
    };
    this.loadershow = true;
    this.resellerService.getConnectorList(connArgs).subscribe(
      (data) => {
        if (
          data.info &&
          data.info.connetcorDetails &&
          data.info.connetcorDetails.length > 0 &&
          data.info.applicationDetails
        ) {
          for (let connData of data.info.connetcorDetails) {
            connData.applicationID = conn.id;
            connData.applicationName = conn.name;
            connData.applicationName2 = conn.name;
            connData.developerID = conn.developerId;
            connData.lastRenewedAt = data.info.applicationDetails.lastRenewedAt;
            this.connectorList.push(connData);
          }
          let totalData = {
            applicationName: "",
            name: "Total",
            lastRenewedAt: "",
          };
          this.connectorList.push(totalData);
        } else {
          let emptyCon = {
            applicationName: conn.name,
            applicationName2: conn.name,
            name: "No Connectors Found",
            lastRenewedAt: "",
            todaysSentMessage: "NA",
            todaysReceivedMessage: "NA",
            weekSentMessage: "NA",
            weekReceivedMessage: "NA",
            monthSentMessage: "NA",
            monthReceivedMessage: "NA",
            yearSentMessage: "NA",
            yearReceivedMessage: "NA",
          };
          this.connectorList.push(emptyCon);
        }
      },
      (err) => {
        this.loadershow = false;
        console.log("Error op", err);
      }
    );
  }

  getCounts(subData) {
    this.loadershow = true;
    this.Loader = true;
    let itemsProcessed = 0;
    if (subData) {
      const requestData = subData;
      requestData.forEach((element: any) => {
        if (element.name !== "Total" && element.name !== "No Connectors Found") {
          let arg1 = {
            developerId: element.developerID,
            applicationId: element.applicationID,
            connectorId: element.id,
            fromDate: this.todaysDate,
            toDate: this.todaysDate,
          };

          let todaysSentMessageData = this.applicationService.getConnectorMessageSentCount(arg1);
          let todaysReceivedMessageData = this.dashboardService.getReceivedCountByConnectors(arg1);

          let args2 = {
            developerId: element.developerID,
            applicationId: element.applicationID,
            connectorId: element.id,
            fromDate: this.currentWeekStarts,
            toDate: this.currentWeekEnds,
          };
          
          let weekSentMessageData = this.applicationService.getConnectorMessageSentCount(args2);
          let weekReceivedMessageData = this.dashboardService.getReceivedCountByConnectors(args2);

          let args3 = {
            developerId: element.developerID,
            applicationId: element.applicationID,
            connectorId: element.id,
            fromDate: this.currentMonthStarts,
            toDate: this.currentMonthEnds,
          };
          
          let monthSentMessageData = this.applicationService.getConnectorMessageSentCount(args3);
          let monthReceivedMessageData = this.dashboardService.getReceivedCountByConnectors(args3);

          let args4 = {
            developerId: element.developerID,
            applicationId: element.applicationID,
            connectorId: element.id,
            fromDate: this.currentYearStarts,
            toDate: this.currentYearEnds,
          };
          let yearSentMessageData = this.applicationService.getConnectorMessageSentCount(args4);
          let yearReceivedMessageData = this.dashboardService.getReceivedCountByConnectors(args4);
          
          forkJoin([todaysSentMessageData, todaysReceivedMessageData, weekSentMessageData, weekReceivedMessageData,
            monthSentMessageData, monthReceivedMessageData, yearSentMessageData, yearReceivedMessageData
          ]).pipe(delay(2000)).subscribe(results => {
            element.todaysSentMessage =
              results[0].info && results[0].info.count
                ? results[0].info.count
                : 0;
            element.todaysReceivedMessage = results[1].info
              ? results[1].info
              : 0;
            element.weekSentMessage =
              results[2].info && results[2].info.count
                ? results[2].info.count
                : 0;
            element.weekReceivedMessage = results[3].info ? results[3].info : 0;
            element.monthSentMessage = results[4].info && results[4].info.count ? results[4].info.count : 0;
            element.monthReceivedMessage = results[5].info ? results[5].info : 0;
            element.yearSentMessage =
              results[6].info && results[6].info.count
                ? results[6].info.count
                : 0;
            element.yearReceivedMessage = results[7].info ? results[7].info : 0;
          });
          itemsProcessed++;
        } else {
          itemsProcessed++;
        }
      });
      subData = requestData;
      this.ELEMENT_DATA = subData;
    }
    if (itemsProcessed == subData.length) {
      this.processEachConnectorData();
    }
  }

  pageChanged2(page) {
    this.product = [];
    this.ELEMENT_DATA = [];
    this.dataSource = [];
    this.page = page;
    let app1 = this.applicationList.slice(
      (this.page - 1) * 5,
      (this.page - 1) * 5 + 5
    );
    this.integration(app1);
  }
}
